import styles from './FaqButtonAccordion.scss';

import cx from 'classnames';
import React from 'react';

import { Accordion } from '../Accordion';
import { AccordionItem, AccordionItemId, OpenSections } from '../models';
import { FaqButtonAccordionIcon } from './FaqButtonAccordionIcon';

interface FaqButtonAccordionProps {
  items?: AccordionItem[];
  className?: string;
}

const getAccordionRowsJSX = (items: AccordionItem[], onToggled: (id: AccordionItemId) => void, openSections: OpenSections) => {
  return items.map((item, index) => (
    <React.Fragment key={item.id}>
      <Accordion.Header
        itemId={item.id}
        defaultOpen={item.defaultOpen}
        onToggled={onToggled}
        openSections={openSections}
        className={cx(item.headerClassName, styles.header)}
      >
        <FaqButtonAccordionIcon open={openSections[index]} />
        {item.title}
      </Accordion.Header>
      <Accordion.Body
        itemId={item.id}
        openSections={openSections}
        className={styles.body}
      >
        {item.body}
      </Accordion.Body>
    </React.Fragment>
  ));
};

const FaqButtonAccordion: React.FC<FaqButtonAccordionProps> = props => {
  const { items = [], className } = props;
  if (!items.length) return null;

  return (
    <Accordion
      className={cx(styles.faqAccordion, className)}
    >
      {(onToggled, openSections) => (
        getAccordionRowsJSX(items, onToggled, openSections)
      )}
    </Accordion>
  );
};

export { FaqButtonAccordion };

FaqButtonAccordion.displayName = 'FaqButtonAccordion';
